<life-di-nav></life-di-nav>
<lifedi-breadcrumb></lifedi-breadcrumb>

<div class="container-fulid text-center overflow-hidden py-6">
    <div class="row justify-content-center">
        <div class="col-8">
            <h1 class="lifedi-color">
                เอกสารการขาย
            </h1>
        </div>
    </div>
    <div class="row justify-content-center">
        <ul>
            <li><a [class.text-danger]="tableName === 'quotation'"
                    (click)="getAllPayment('quotation', bankAccount)">ใบเสนอราคา</a>
            </li>
            <li><a [class.text-danger]="tableName === 'invoice'"
                    (click)="getAllPayment('invoice', bankAccount)">ใบแจ้งหนี้</a></li>
            <li><a [class.text-danger]="tableName === 'receipt'"
                    (click)="getAllPayment('receipt', bankAccount)">ใบเสร็จ</a>
            </li>
        </ul>
    </div>
    <div class="row d-flex pb-4 justify-content-center">
        <input type="text" class="form-control search" placeholder="ค้นหา" name="search" [(ngModel)]="search"
            (keyup)="searching()">
        <select class="custom-select form-control"
            style="display: inline; position: absolute; left: 3%; margin-top: 0px; padding: 0 25px; width: 20%;"
            [(ngModel)]="bankAccount" (ngModelChange)="getAllPayment(tableName, bankAccount)">
            <option value="All">บัญชีทั้งหมด</option>
            <option *ngFor="let s of account" [value]="s.ACCOUNT_GROUP">
                บัญชี{{ s.ACCOUNTING_NAME }} ({{ s.ACCOUNTING_ID }})
            </option>
        </select>
        <lifedi-btn *ngIf="tableName === 'quotation'" lable="สร้างใบเสนอราคา"
            customStyle="position: absolute; right: 3%; margin-top: 0px; padding: 0 25px; background: #005C3D; color: #FFFFFF"
            (click)="createQuotation()">
        </lifedi-btn>
        <lifedi-btn *ngIf="tableName === 'receipt'" lable="สร้างใบเสร็จส่วนบุคคล"
            customStyle="position: absolute; right: 3%; margin-top: 0px; padding: 0 25px; background: #005C3D; color: #FFFFFF"
            (click)="createPersonalReceipt()">
        </lifedi-btn>
    </div>

    <!-- not search -->
    <nz-table *ngIf="!isSearch" #groupingTable [nzData]="allPayment" nzBordered nzSize="large"
        class="table table-striped">
        <thead *ngIf="tableName === 'quotation'">
            <tr>
                <th class="text-center" [nzSortFn]="sortQuotationNoFn">รหัสใบเสนอรายการ</th>
                <th class="text-center">ชื่อลูกค้า</th>
                <th class="text-center">หัวข้อ</th>
                <th class="text-center" [nzSortFn]="sortQuotationDateFn">วันที่</th>
                <th class="text-center" [nzSortFn]="sortTotalFn">ยอดรวมสุทธิ</th>
                <th class="text-center">ผู้สร้าง</th>
                <th class="text-center" [nzFilters]="filterQuotationStatus" [nzFilterFn]="statusFilterFn">สถานะ</th>
                <th class="text-center">รายละเอียด</th>
                <th class="text-center">เพิ่มเติม</th>
            </tr>
        </thead>

        <thead *ngIf="tableName === 'invoice'">
            <tr>
                <th class="text-center" [nzSortFn]="sortInvoiceNoFn">รหัสใบแจ้งหนี้</th>
                <th class="text-center" [nzSortFn]="sortQuotationNoFn">เลขที่ใบเสนอราคา</th>
                <th class="text-center">ชื่อลูกค้า</th>
                <th class="text-center">หัวข้อ</th>
                <th class="text-center" [nzSortFn]="sortInvoiceDateFn">วันที่</th>
                <th class="text-center" [nzSortFn]="sortInvoiceDateEndFn">วันที่ครบกำหนด</th>
                <th class="text-center" [nzSortFn]="sortInvTotalFn">ยอดรวมสุทธิ</th>
                <th class="text-center">ผู้สร้าง</th>
                <th class="text-center" [nzFilters]="filterStatus" [nzFilterFn]="statusFilterFn">สถานะ</th>
                <th class="text-center">รายละเอียด</th>
                <th class="text-center">เพิ่มเติม</th>
            </tr>
        </thead>

        <thead *ngIf="tableName === 'receipt'">
            <tr>
                <th class="text-center" [nzSortFn]="sortReceiptNoFn">รหัสใบเสร็จ</th>
                <th class="text-center" [nzSortFn]="sortInvoiceNoRecFn">รหัสใบแจ้งหนี้</th>
                <!-- <th class="text-center" [nzSortFn]="sortInvoiceNoFn">รหัสใบแจ้งหนี้</th> -->
                <th class="text-center">ชื่อลูกค้า</th>
                <th class="text-center" [nzSortFn]="sortReceiptDateFn">วันที่</th>
                <th class="text-center" [nzSortFn]="sortRecTotalFn">ยอดรวมสุทธิ</th>
                <th class="text-center">ผู้สร้าง</th>
                <th class="text-center" [nzFilters]="filterType" [nzFilterFn]="typeFilterFn">ประเภท</th>
                <th class="text-center" [nzFilters]="filterStatus" [nzFilterFn]="statusFilterFn">สถานะ</th>
                <th class="text-center">รายละเอียด</th>
                <th class="text-center">เพิ่มเติม</th>
            </tr>
        </thead>

        <!-- Quotation -->
        <tbody *ngIf="tableName === 'quotation'">
            <tr *ngFor="let data of groupingTable.data">
                <td class="text-center">{{ data.QUOTATION_NO }}-V{{ data.QUOTATION_VERSION }}</td>
                <td class="text-center">{{ data.CUSTOMER_NAME }}</td>
                <td class="text-center">{{ data.TITLE }}</td>
                <td class="text-center">{{ data.QUOTATION_START | date }}</td>
                <td class="text-center" *ngIf="data.STATUS === 'Partial'">
                    {{ data.TOTAL_PRICE | number : '1.2-2' }} /
                    <span (click)="detailPartial(data.QUOTATION_NO, data.QUOTATION_VERSION)" class="text-primary"
                        style="cursor: pointer;">
                        {{ data.PATAIL_PRICE | number : '1.2-2' }}
                        <span style="top: 9px; width: 15px;"
                            class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-primary text-white">
                            !
                        </span>
                    </span>
                </td>
                <td class="text-center" *ngIf="data.STATUS === 'Done'">
                    {{ data.TOTAL_PRICE | number : '1.2-2' }}
                </td>
                <td class="text-center" *ngIf="data.STATUS === 'Cancel' || data.STATUS === 'Wait'">
                    {{ data.TOTAL_PRICE | number : '1.2-2' }}
                </td>
                <td class="text-center">{{ data.CREATE_USER }}</td>
                <td class="text-center" *ngIf="data.STATUS === 'Done'">
                    <p class="text-success">สำเร็จ</p>
                </td>
                <td class="text-center" *ngIf="data.STATUS === 'Wait'">
                    <p class="lifedi-color">รอการดำเนินการ</p>
                </td>
                <td class="text-center" *ngIf="data.STATUS === 'Cancel'">
                    <p class="text-danger">ไม่สำเร็จ</p>
                </td>
                <td class="text-center" *ngIf="data.STATUS === 'Partial'">
                    <p class="text-primary">แบ่งจ่าย</p>
                </td>
                <td class="text-center">
                    <a (click)="editQuotation(data.QUOTATION_NO, data.QUOTATION_VERSION)">
                        <img src="assets/employee.png" alt="" width="25px">
                    </a>
                </td>
                <td class="text-center">
                    <a class="nav-link pt-0" href="#" id="Dropdown" role="button" data-toggle="dropdown"
                        aria-haspopup="true" aria-expanded="false">
                        <img src="assets/dots.png" width="25" height="25" alt="">
                    </a>
                    <div class="dropdown-menu dropdown-menu-right login-desktop" aria-labelledby="Dropdown">
                        <a *ngIf="data.STATUS === 'Wait'"
                            (click)="createInvoiceByID(data.QUOTATION_NO, data.QUOTATION_VERSION)"
                            class="list-group-item list-group-item-action flex-column align-items-start"
                            style="color: #060e9f;">
                            สร้างใบแจ้งหนี้
                        </a>
                        <a *ngIf="data.STATUS === 'Wait' || data.STATUS === 'Partial'"
                            (click)="PartialInvoice(data.QUOTATION_NO, data.QUOTATION_VERSION)"
                            class="list-group-item list-group-item-action flex-column align-items-start text-primary">
                            แบ่งจ่ายใบแจ้งหนี้
                        </a>
                        <a *ngIf="data.STATUS === 'Wait'"
                            (click)="cancelQuotation(data.QUOTATION_NO, tableName, data.QUOTATION_VERSION)"
                            class="list-group-item list-group-item-action flex-column align-items-start text-danger">
                            ยกเลิก
                        </a>
                        <a *ngIf="data.STATUS === 'Cancel'"
                            (click)="cancelNote(data.QUOTATION_NO, data.CANCEL_REMARK, tableName, data.QUOTATION_VERSION)"
                            class="list-group-item list-group-item-action flex-column align-items-start"
                            style="color: #060e9f;">
                            เหตุผลยกเลิก
                        </a>
                    </div>
                </td>
            </tr>
        </tbody>

        <!-- invoice -->
        <tbody *ngIf="tableName === 'invoice'">
            <tr *ngFor="let data of groupingTable.data">
                <td class="text-center">{{ data.INVOICE_NO }}</td>
                <td class="text-center">{{ data.QUOTATION }}</td>
                <td class="text-center">{{ data.CUSTOMER_NAME }}</td>
                <td class="text-center">{{ data.TITLE }}</td>
                <td class="text-center">{{ data.INVOICE_START | date }}</td>
                <td class="text-center">{{ data.INVOICE_END | date }}</td>
                <td class="text-center">{{ data.TOTAL | number : '1.2-2' }}</td>

                <td class="text-center">{{ data.CREATE_USER }}</td>
                <td class="text-center" *ngIf="data.STATUS === 'Done'">
                    <p class="text-success">สำเร็จ</p>
                </td>
                <td class="text-center" *ngIf="data.STATUS === 'Wait'">
                    <p class="lifedi-color">รอชำระ</p>
                </td>
                <td class="text-center" *ngIf="data.STATUS === 'Cancel'">
                    <p class="text-danger">ไม่สำเร็จ</p>
                </td>
                <td class="text-center">
                    <a (click)="editInvoice(data.INVOICE_NO, data.CREATE_TYPE, data.QUOTATION_VERSION)">
                        <img src="assets/employee.png" alt="" width="25px">
                    </a>
                </td>
                <td class="text-center">
                    <a class="nav-link pt-0" href="#" id="Dropdown" role="button" data-toggle="dropdown"
                        aria-haspopup="true" aria-expanded="false">
                        <img src="assets/dots.png" width="25" height="25" alt="">
                    </a>
                    <div class="dropdown-menu dropdown-menu-right login-desktop" aria-labelledby="Dropdown">
                        <a *ngIf="data.STATUS === 'Wait'" (click)="createReceiptFromInvoice(data.INVOICE_NO)"
                            class="list-group-item list-group-item-action flex-column align-items-start"
                            style="color: #060e9f;">
                            สร้างใบเสร็จ
                        </a>
                        <a *ngIf="data.STATUS === 'Wait'" (click)="cancelInvoice(data.INVOICE_NO, tableName)"
                            class="list-group-item list-group-item-action flex-column align-items-start text-danger">
                            ยกเลิก
                        </a>
                        <a *ngIf="data.STATUS === 'Cancel'"
                            (click)="cancelNote(data.INVOICE_NO ,data.CANCEL_REMARK, tableName, '')"
                            class="list-group-item list-group-item-action flex-column align-items-start"
                            style="color: #060e9f;">
                            เหตุผลยกเลิก
                        </a>
                    </div>
                </td>
            </tr>
        </tbody>

        <!-- receipt -->
        <tbody *ngIf="tableName === 'receipt'">
            <tr *ngFor="let data of groupingTable.data">
                <td class="text-center">{{ data.RECEIPT_NO }}</td>
                <td class="text-center">
                    <span *ngIf="data.INVOICE_NO">{{ data.INVOICE_NO }}</span>
                    <span *ngIf="!data.INVOICE_NO"> - </span>
                </td>
                <td class="text-center">
                    <span *ngIf="data.CUSTOMER_NAME">{{ data.CUSTOMER_NAME }}</span>
                    <span *ngIf="!data.CUSTOMER_NAME"> - </span>
                </td>
                <td class="text-center">{{ data.CREATE_DATE | date }}</td>
                <td class="text-center">{{ data.GRAND_TOTAL | number : '1.2-2' }}</td>

                <td class="text-center">{{ data.CREATE_USER }}</td>
                <td class="text-center">{{ data.CUSTOMER_TYPE }}</td>
                <!-- <td class="text-center" *ngIf="data.TYPE === 'company'">
                    บริษัท
                </td>
                <td class="text-center" *ngIf="data.TYPE === 'personal'">
                    ส่วนบุคคล
                </td> -->
                <td class="text-center" *ngIf="data.STATUS === 'Done'">
                    <p class="text-success">สำเร็จ</p>
                </td>
                <td class="text-center" *ngIf="data.STATUS === 'Cancel'">
                    <p class="text-danger">ยกเลิก</p>
                </td>
                <td class="text-center">
                    <a (click)="editReceipt(data.RECEIPT_NO, data.RECEIPT_TYPE, data.CUSTOMER_TYPE)">
                        <img src="assets/employee.png" alt="" width="25px">
                    </a>
                </td>
                <td class="text-center">
                    <a class="nav-link pt-0" href="#" id="Dropdown" role="button" data-toggle="dropdown"
                        aria-haspopup="true" aria-expanded="false">
                        <img src="assets/dots.png" width="25" height="25" alt="">
                    </a>
                    <div class="dropdown-menu dropdown-menu-right login-desktop" aria-labelledby="Dropdown">
                        <a *ngIf="data.STATUS === 'Cancel'"
                            (click)="cancelNote(data.RECEIPT_NO, data.CANCEL_REMARK, tableName, '')"
                            class="list-group-item list-group-item-action flex-column align-items-start"
                            style="color: #060e9f;">
                            เหตุผลยกเลิก
                        </a>
                        <a *ngIf="data.STATUS === 'Done'" (click)="cancelReceipt(data.RECEIPT_NO, tableName)"
                            class="list-group-item list-group-item-action flex-column align-items-start text-danger">
                            ยกเลิก
                        </a>
                    </div>
                </td>
            </tr>
        </tbody>
    </nz-table>

    <!-- search -->
    <nz-table *ngIf="isSearch" #groupingTable [nzData]="listOfData" nzBordered nzSize="large"
        class="table table-striped">
        <thead *ngIf="tableName === 'quotation'">
            <tr>
                <th class="text-center" [nzSortFn]="sortQuotationNoFn">รหัสใบเสนอรายการ</th>
                <th class="text-center">ชื่อลูกค้า</th>
                <th class="text-center">หัวข้อ</th>
                <th class="text-center" [nzSortFn]="sortQuotationDateFn">วันที่</th>
                <th class="text-center" [nzSortFn]="sortTotalFn">ยอดรวมสุทธิ</th>
                <th class="text-center">ผู้สร้าง</th>
                <th class="text-center" [nzFilters]="filterQuotationStatus" [nzFilterFn]="statusFilterFn">สถานะ</th>
                <th class="text-center">รายละเอียด</th>
                <th class="text-center">เพิ่มเติม</th>
            </tr>
        </thead>

        <thead *ngIf="tableName === 'invoice'">
            <tr>
                <th class="text-center" [nzSortFn]="sortInvoiceNoFn">รหัสใบแจ้งหนี้</th>
                <th class="text-center" [nzSortFn]="sortQuotationNoFn">เลขที่ใบเสนอราคา</th>
                <th class="text-center">ชื่อลูกค้า</th>
                <th class="text-center">หัวข้อ</th>
                <th class="text-center" [nzSortFn]="sortInvoiceDateFn">วันที่</th>
                <th class="text-center" [nzSortFn]="sortInvoiceDateEndFn">วันที่ครบกำหนด</th>
                <th class="text-center" [nzSortFn]="sortInvTotalFn">ยอดรวมสุทธิ</th>
                <th class="text-center">ผู้สร้าง</th>
                <th class="text-center" [nzFilters]="filterStatus" [nzFilterFn]="statusFilterFn">สถานะ</th>
                <th class="text-center">รายละเอียด</th>
                <th class="text-center">เพิ่มเติม</th>
            </tr>
        </thead>

        <thead *ngIf="tableName === 'receipt'">
            <tr>
                <th class="text-center" [nzSortFn]="sortReceiptNoFn">รหัสใบเสร็จ</th>
                <th class="text-center" [nzSortFn]="sortInvoiceNoRecFn">รหัสใบแจ้งหนี้</th>
                <!-- <th class="text-center" [nzSortFn]="sortInvoiceNoFn">รหัสใบแจ้งหนี้</th> -->
                <th class="text-center">ชื่อลูกค้า</th>
                <th class="text-center" [nzSortFn]="sortReceiptDateFn">วันที่</th>
                <th class="text-center" [nzSortFn]="sortRecTotalFn">ยอดรวมสุทธิ</th>
                <th class="text-center">ผู้สร้าง</th>
                <th class="text-center" [nzFilters]="filterType" [nzFilterFn]="typeFilterFn">ประเภท</th>
                <th class="text-center" [nzFilters]="filterStatus" [nzFilterFn]="statusFilterFn">สถานะ</th>
                <th class="text-center">รายละเอียด</th>
                <th class="text-center">เพิ่มเติม</th>
            </tr>
        </thead>

        <!-- Quotation -->
        <tbody *ngIf="tableName === 'quotation'">
            <tr *ngFor="let data of groupingTable.data">
                <td class="text-center">{{ data.QUOTATION_NO }}-V{{ data.QUOTATION_VERSION }}</td>
                <td class="text-center">{{ data.CUSTOMER_NAME }}</td>
                <td class="text-center">{{ data.TITLE }}</td>
                <td class="text-center">{{ data.QUOTATION_START | date }}</td>
                <td class="text-center" *ngIf="data.STATUS === 'Partial'">
                    {{ data.TOTAL_PRICE | number : '1.2-2' }} /
                    <span (click)="detailPartial(data.QUOTATION_NO, data.QUOTATION_VERSION)" class="text-primary"
                        style="cursor: pointer;">
                        {{ data.PATAIL_PRICE | number : '1.2-2' }}
                        <span style="top: 9px; width: 15px;"
                            class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-primary text-white">
                            !
                        </span>
                    </span>
                </td>
                <td class="text-center" *ngIf="data.STATUS === 'Done'">
                    {{ data.TOTAL_PRICE | number : '1.2-2' }}
                </td>
                <td class="text-center" *ngIf="data.STATUS === 'Cancel' || data.STATUS === 'Wait'">
                    {{ data.TOTAL_PRICE | number : '1.2-2' }}
                </td>
                <td class="text-center">{{ data.CREATE_USER }}</td>
                <td class="text-center" *ngIf="data.STATUS === 'Done'">
                    <p class="text-success">สำเร็จ</p>
                </td>
                <td class="text-center" *ngIf="data.STATUS === 'Wait'">
                    <p class="lifedi-color">รอการดำเนินการ</p>
                </td>
                <td class="text-center" *ngIf="data.STATUS === 'Cancel'">
                    <p class="text-danger">ไม่สำเร็จ</p>
                </td>
                <td class="text-center" *ngIf="data.STATUS === 'Partial'">
                    <p class="text-primary">แบ่งจ่าย</p>
                </td>
                <td class="text-center">
                    <a (click)="editQuotation(data.QUOTATION_NO, data.QUOTATION_VERSION)">
                        <img src="assets/employee.png" alt="" width="25px">
                    </a>
                </td>
                <td class="text-center">
                    <a class="nav-link pt-0" href="#" id="Dropdown" role="button" data-toggle="dropdown"
                        aria-haspopup="true" aria-expanded="false">
                        <img src="assets/dots.png" width="25" height="25" alt="">
                    </a>
                    <div class="dropdown-menu dropdown-menu-right login-desktop" aria-labelledby="Dropdown">
                        <a *ngIf="data.STATUS === 'Wait'"
                            (click)="createInvoiceByID(data.QUOTATION_NO, data.QUOTATION_VERSION)"
                            class="list-group-item list-group-item-action flex-column align-items-start"
                            style="color: #060e9f;">
                            สร้างใบแจ้งหนี้
                        </a>
                        <a *ngIf="data.STATUS === 'Wait' || data.STATUS === 'Partial'"
                            (click)="PartialInvoice(data.QUOTATION_NO, data.QUOTATION_VERSION)"
                            class="list-group-item list-group-item-action flex-column align-items-start text-primary">
                            แบ่งจ่ายใบแจ้งหนี้
                        </a>
                        <a *ngIf="data.STATUS === 'Wait'"
                            (click)="cancelQuotation(data.QUOTATION_NO, tableName, data.QUOTATION_VERSION)"
                            class="list-group-item list-group-item-action flex-column align-items-start text-danger">
                            ยกเลิก
                        </a>
                        <a *ngIf="data.STATUS === 'Cancel'"
                            (click)="cancelNote(data.QUOTATION_NO, data.CANCEL_REMARK, tableName, data.QUOTATION_VERSION)"
                            class="list-group-item list-group-item-action flex-column align-items-start"
                            style="color: #060e9f;">
                            เหตุผลยกเลิก
                        </a>
                    </div>
                </td>
            </tr>
        </tbody>

        <!-- invoice -->
        <tbody *ngIf="tableName === 'invoice'">
            <tr *ngFor="let data of groupingTable.data">
                <td class="text-center">{{ data.INVOICE_NO }}</td>
                <td class="text-center">{{ data.QUOTATION }}</td>
                <td class="text-center">{{ data.CUSTOMER_NAME }}</td>
                <td class="text-center">{{ data.TITLE }}</td>
                <td class="text-center">{{ data.INVOICE_START | date }}</td>
                <td class="text-center">{{ data.INVOICE_END | date }}</td>
                <td class="text-center">{{ data.TOTAL | number : '1.2-2' }}</td>

                <td class="text-center">{{ data.CREATE_USER }}</td>
                <td class="text-center" *ngIf="data.STATUS === 'Done'">
                    <p class="text-success">สำเร็จ</p>
                </td>
                <td class="text-center" *ngIf="data.STATUS === 'Wait'">
                    <p class="lifedi-color">รอชำระ</p>
                </td>
                <td class="text-center" *ngIf="data.STATUS === 'Cancel'">
                    <p class="text-danger">ไม่สำเร็จ</p>
                </td>
                <td class="text-center">
                    <a (click)="editInvoice(data.INVOICE_NO, data.CREATE_TYPE, data.QUOTATION_VERSION)">
                        <img src="assets/employee.png" alt="" width="25px">
                    </a>
                </td>
                <td class="text-center">
                    <a class="nav-link pt-0" href="#" id="Dropdown" role="button" data-toggle="dropdown"
                        aria-haspopup="true" aria-expanded="false">
                        <img src="assets/dots.png" width="25" height="25" alt="">
                    </a>
                    <div class="dropdown-menu dropdown-menu-right login-desktop" aria-labelledby="Dropdown">
                        <a *ngIf="data.STATUS === 'Wait'" (click)="createReceiptFromInvoice(data.INVOICE_NO)"
                            class="list-group-item list-group-item-action flex-column align-items-start"
                            style="color: #060e9f;">
                            สร้างใบเสร็จ
                        </a>
                        <a *ngIf="data.STATUS === 'Wait'" (click)="cancelInvoice(data.INVOICE_NO, tableName)"
                            class="list-group-item list-group-item-action flex-column align-items-start text-danger">
                            ยกเลิก
                        </a>
                        <a *ngIf="data.STATUS === 'Cancel'"
                            (click)="cancelNote(data.INVOICE_NO ,data.CANCEL_REMARK, tableName, '')"
                            class="list-group-item list-group-item-action flex-column align-items-start"
                            style="color: #060e9f;">
                            เหตุผลยกเลิก
                        </a>
                    </div>
                </td>
            </tr>
        </tbody>

        <!-- receipt -->
        <tbody *ngIf="tableName === 'receipt'">
            <tr *ngFor="let data of groupingTable.data">
                <td class="text-center">{{ data.RECEIPT_NO }}</td>
                <td class="text-center">
                    <span *ngIf="data.INVOICE_NO">{{ data.INVOICE_NO }}</span>
                    <span *ngIf="!data.INVOICE_NO"> - </span>
                </td>
                <td class="text-center">
                    <span *ngIf="data.CUSTOMER_NAME">{{ data.CUSTOMER_NAME }}</span>
                    <span *ngIf="!data.CUSTOMER_NAME"> - </span>
                </td>
                <td class="text-center">{{ data.CREATE_DATE | date }}</td>
                <td class="text-center">{{ data.GRAND_TOTAL | number : '1.2-2' }}</td>

                <td class="text-center">{{ data.CREATE_USER }}</td>
                <td class="text-center">{{ data.CUSTOMER_TYPE }}</td>
                <!-- <td class="text-center" *ngIf="data.TYPE === 'company'">
                    บริษัท
                </td>
                <td class="text-center" *ngIf="data.TYPE === 'personal'">
                    ส่วนบุคคล
                </td> -->
                <td class="text-center" *ngIf="data.STATUS === 'Done'">
                    <p class="text-success">สำเร็จ</p>
                </td>
                <td class="text-center" *ngIf="data.STATUS === 'Cancel'">
                    <p class="text-danger">ยกเลิก</p>
                </td>
                <td class="text-center">
                    <a (click)="editReceipt(data.RECEIPT_NO, data.RECEIPT_TYPE, data.CUSTOMER_TYPE)">
                        <img src="assets/employee.png" alt="" width="25px">
                    </a>
                </td>
                <td class="text-center">
                    <a class="nav-link pt-0" href="#" id="Dropdown" role="button" data-toggle="dropdown"
                        aria-haspopup="true" aria-expanded="false">
                        <img src="assets/dots.png" width="25" height="25" alt="">
                    </a>
                    <div class="dropdown-menu dropdown-menu-right login-desktop" aria-labelledby="Dropdown">
                        <a *ngIf="data.STATUS === 'Cancel'"
                            (click)="cancelNote(data.RECEIPT_NO, data.CANCEL_REMARK, tableName, '')"
                            class="list-group-item list-group-item-action flex-column align-items-start"
                            style="color: #060e9f;">
                            เหตุผลยกเลิก
                        </a>
                        <a *ngIf="data.STATUS === 'Done'" (click)="cancelReceipt(data.RECEIPT_NO, tableName)"
                            class="list-group-item list-group-item-action flex-column align-items-start text-danger">
                            ยกเลิก
                        </a>
                    </div>
                </td>
            </tr>
        </tbody>
    </nz-table>

</div>

<div *ngIf="isLoading">
    <div
        style="position: fixed; z-index: 900; width: 100vw; height: 100vh; opacity: 80; top: 0; left: 0; background: #e8e8e880;">
    </div>
    <mat-spinner class="spinner-center" style="z-index: 1000;"></mat-spinner>
</div>